<!--
  @copyright 汽车商贸管理平台 V1.0
  @year 2026
  @description OAuthCallback 钉钉 OAuth2 免登回调（静默换 token 后回原页）
-->
<template>
  <div class="oauth-cb">
    <van-loading color="#1989fa" vertical>钉钉登录中...</van-loading>
  </div>
</template>

<script>
import { dingTalkOAuthLogin } from "../api/index";
import { Toast } from "vant";

export default {
  name: "OAuthCallback",
  data() {
    return { done: false };
  },
  created() {
    this.handle();
  },
  methods: {
    async handle() {
      if (this.done) return;
      this.done = true;
      const code = this.$route.query.code || "";
      const state = this.$route.query.state || "/";
      if (!code) {
        Toast.fail("未获取到钉钉授权码");
        this.$router.replace("/login");
        return;
      }
      try {
        const res = await dingTalkOAuthLogin({
          code,
          browser: "DingTalk",
          os: "DingTalk",
          deviceInfo: navigator.userAgent || "",
        });
        if (res && res.code === 0) {
          localStorage.setItem("token", res.data);
          this.$store.commit("LOGIN_IN", res.data);
          const target = state && state.indexOf("/") === 0 ? state : "/";
          this.$router.replace(target);
        } else {
          Toast.fail((res && res.message) || "钉钉登录失败");
          this.$router.replace("/login");
        }
      } catch (error) {
        Toast.fail((error && error.message) || "钉钉登录失败");
        this.$router.replace("/login");
      }
    },
  },
};
</script>

<style scoped>
.oauth-cb {
  max-width: 512px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
